import React from "react";
import Loader from "../../../../components/Loader";
import Pagination from "../../../../components/Pagination";
import { useEmbryoTransferPermitRequests } from "../hooks/useEmbryoTransferPermitRequests";
import EmbryoPermitFilter from "../Components/EmbryoPermitFilter";
import EmbryoPermitTable from "../Components/EmbryoPermitTable";

/**
 * Embryo Transfer Permit Requests Page
 * Embedded tab inside OwnerProfile.
 * Adheres strictly to EAHS shared components and design system.
 */
export default function EmbryoTransferPermitsRequestsPage() {
    const {
        permits,
        loading,
        currentPage,
        totalPages,
        isLastPage,
        searchTerm,
        selectedStatus,
        handleSearchChange,
        handleSearchSubmit,
        handleStatusChange,
        goToPage,
    } = useEmbryoTransferPermitRequests();

    return (
        <>
            {/* Search and Status Filter */}
            <EmbryoPermitFilter
                searchTerm={searchTerm}
                selectedStatus={selectedStatus}
                onSearchChange={handleSearchChange}
                onStatusChange={handleStatusChange}
                onSearchSubmit={handleSearchSubmit}
            />

            {/* Loading Indicator */}
            {loading && <Loader />}

            {/* Table */}
            {!loading && <EmbryoPermitTable permits={permits} />}

            {/* Shared Pagination */}
            {!loading && (
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    isLastPage={isLastPage}
                    onPageChange={goToPage}
                />
            )}
        </>
    );
}
